import React, { useState } from 'react';
import "./NoteCard.css"


function NoteCard(){
    const [isPinned, setIsPinned] = useState(false);

    const togglePinned = () => {
        setIsPinned(!isPinned);
    };

    return(
        <div className="note-card">
            <i onClick={togglePinned} className={`heart-icon fa-solid fa-heart ${isPinned ? 'pinned' : ''}`}></i>
            <h3 className='part-heading py-2 px-1 m-0'>New Note</h3>
            <div className='part-content pt-1 px-1'>
                <p className='part-inner-heading'>
                    Enter your note
                </p>
            </div>
        </div>
    )
}

export default NoteCard;